import { createAction } from '@reduxjs/toolkit'
import { createPromiseAction } from 'redux-saga-promise-actions'
import * as types from './types'

export const getDoormen = createAction(types.GET_DOORMEN)
export const getDoormenSuccessful = createAction(types.GET_DOORMEN_SUCCESSFUL)
export const getDoormenFailure = createAction(types.GET_DOORMEN_FAILURE)

export const createDoorman = createAction(types.CREATE_DOORMAN)
export const createDoormanSuccessful = createAction(
  types.CREATE_DOORMAN_SUCCESSFUL
)
export const createDoormanFailure = createAction(types.CREATE_DOORMAN_FAILURE)

export const removeDoormanRSPA = createPromiseAction(
  types.REMOVE_DOORMAN_RSPA
)()
